// Endpoint unificado /algorithm/rules — não força algoritmo (algorithm_keys vem
// do payload) e aceita ?algorithm_key= para filtrar a listagem por tela.
export default {
  index: { method: 'get', url: 'algorithm/rules' },
  show: { method: 'get', url: 'algorithm/rules/{id}' },
  store: { method: 'post', url: 'algorithm/rules' },
  update: { method: 'put', url: 'algorithm/rules/{id}' },
  duplicate: { method: 'post', url: 'algorithm/rules/{id}/duplicate' },
  toggle: { method: 'post', url: 'algorithm/rules/{id}/toggle' },
  destroy: { method: 'delete', url: 'algorithm/rules/{id}' },
}
